import { Icon } from "@iconify/react";
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import peopleFill from "@iconify/icons-eva/person-fill";
import shoppingBagFill from "@iconify/icons-eva/shopping-bag-fill";
import fileTextFill from "@iconify/icons-eva/file-text-fill";
import lockFill from "@iconify/icons-eva/lock-fill";
import personAddFill from "@iconify/icons-eva/person-add-fill";
import refrence from "@iconify/icons-eva/bulb-fill";
import v2v from "@iconify/icons-eva/message-circle-fill";
import camera from "@iconify/icons-eva/image-2-fill";
import setting from "@iconify/icons-eva/settings-2-fill";
import member from "@iconify/icons-eva/person-add-fill";
import login from "@iconify/icons-eva/log-in-fill";
import poll from "@iconify/icons-eva/bar-chart-fill";
import meeting from "@iconify/icons-eva/people-fill";
import event from "@iconify/icons-eva/bookmark-fill";
import country from "@iconify/icons-eva/flag-fill";
import state from "@iconify/icons-eva/funnel-fill";
import city from "@iconify/icons-eva/grid-fill";
import landmark from "@iconify/icons-eva/pin-fill";
import report from "@iconify/icons-eva/file-text-outline";
import chp from "@iconify/icons-eva/file-add-fill";
import mic from "@iconify/icons-eva/volume-up-fill";
import staff from "@iconify/icons-eva/people-outline";
import task from "@iconify/icons-eva/briefcase-fill";
import lead from "@iconify/icons-eva/trending-up-fill";
import bell from "@iconify/icons-eva/bell-fill";
import dashboard from "@iconify/icons-eva/globe-fill";
import cityambassador from "@iconify/icons-eva/shield-fill";
import documents from "@iconify/icons-eva/folder-fill";
import npmFill from "@iconify/icons-eva/npm-fill";
import personDeleteFill from "@iconify/icons-eva/person-delete-fill";
import pricetagsFill from "@iconify/icons-eva/pricetags-fill";
import travel from "@iconify/icons-eva/compass-fill";
import TourIcon from "@mui/icons-material/Tour";
import Present from "@mui/icons-material/Co2Rounded";
import { CoPresentRounded, FolderShared } from "@mui/icons-material";
import activity from "@iconify/icons-eva/activity-fill";
import verifiedUser from "@iconify/icons-eva/shield-fill";

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;
let loginUser = JSON.parse(localStorage.getItem("userData"));

// eslint-disable-next-line no-sparse-arrays
const adminconfigData = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon(dashboard)
  },
  {
    title: "Lead",
    path: "/lead",
    icon: getIcon(lead)
  },
  {
    title: "Followup Leads",
    path: "/followup-leads",
    icon: getIcon("material-symbols:send")
  },
  // {
  //   title: "Lead Reject Reason",
  //   path: "/lead-reject-reason",
  //   icon: getIcon("material-symbols:cancel-outline-rounded")
  // },
  {
    title: "Member",
    path: "/member",
    icon: getIcon(member)
  },
  // {
  //   title: "Member Deactivate Reason",
  //   path: "/member-deactivate-reason",
  //   icon: getIcon("material-symbols:restart-alt")
  // },
  {
    title: "OBT Approval",
    path: "#",
    icon: getIcon("material-symbols:beenhere-outline"),
    children: [
      { title: "OBT Member Requests", path: "/obt-apply" },
      { title: "Add OBT", path: "/obt-add" },
      { title: "OBT Questions", path: "/obt-questions" }
      // { title: "OBT Reject Reasons", path: "/obt-reject-reasons" }
    ]
  },
  {
    title: "Green Tick Approval",
    path: "#",
    icon: getIcon("material-symbols:supervised-user-circle-outline"),
    children: [
      { title: "V2V Requests", path: "/v2vlist" }
      // { title: "V2V Reject Reasons", path: "/v2v-reject-reasons" }
    ]
  },
  {
    title: "Blue Tick Approval",
    path: "#",
    icon: getIcon("material-symbols:beenhere"),
    children: [
      { title: "BlueTick Member Requests", path: "/bluetick-apply" },
      { title: "Add MGT", path: "/addmgt" },
      { title: "MGT Questions", path: "/mgt-questions" }
      // { title: "Bluetick Reject Reasons", path: "/bluetick-reject-reasons" }
    ]
  },
  {
    title: "Documents",
    path: "/documents",
    icon: getIcon(documents)
  },
  {
    title: "City Ambassador",
    path: "/cityambassador",
    icon: getIcon(cityambassador)
  },
  {
    title: "City Support",
    path: "/city-support",
    icon: getIcon("material-symbols:support-agent")
  },
  {
    title: "Meeting",
    path: "/meeting",
    icon: getIcon(meeting)
  },
  // {
  //   title: "Meeting Feedback For",
  //   path: "/meetingfeedbackfor",
  //   icon: getIcon("material-symbols:person-pin-rounded")
  // },
  {
    title: "Greeting",
    path: "/greeting",
    icon: getIcon(mic)
  },
  {
    title: "Event-Announcement",
    path: "/event-announcement",
    icon: getIcon(event)
  },
  (loginUser?.u_type == 0 ||
    loginUser?.management_p != 0 ||
    (loginUser?.u_type == 2 && loginUser?.p_user_id == 1 && loginUser?.is_subadmin == 1)) && {
    title: "Staff",
    path: "/staff",
    icon: getIcon(staff)
  },
  {
    title: "Deleted Records",
    path: "/deleted-records",
    icon: getIcon("material-symbols:assignment")
  },
  {
    title: "Suggestion",
    path: "/lvb-suggestion",
    icon: getIcon(lead)
  },
  {
    title: "Notifications",
    path: "/lvb-notification",
    icon: getIcon(bell)
  },
  {
    title: "Chapter",
    path: "/chapter",
    icon: getIcon(chp)
  },
  {
    title: "Coordinator Roles",
    path: "/roles",
    icon: getIcon(verifiedUser)
  },
  // {
  //   title: "Gallery",
  //   path: "/gallery",
  //   icon: getIcon(camera),
  // },
  {
    title: "Poll Notification",
    path: "/poll",
    icon: getIcon(poll)
  },
  {
    title: "Dynamic Reasons",
    path: "#",
    icon: getIcon(personDeleteFill),
    children: [
      { title: "Member Deactivate Reason", path: "/member-deactivate-reason" },
      { title: "V2V Reject Reasons", path: "/v2v-reject-reasons" },
      { title: "OBT Reject Reasons", path: "/obt-reject-reasons" },
      { title: "Bluetick Reject Reasons", path: "/bluetick-reject-reasons" },
      { title: "Ask Reject Reasons", path: "/ask-reasons" },
      {
        title: "Lead Reject Reason",
        path: "/lead-reject-reason"
      },
      {
        title: "Meeting Feedback For",
        path: "/meetingfeedbackfor"
      },
      {
        title: "Traveling Purpose",
        path: "/traveling-purpose"
      },
      {
        title: "Lead Status",
        path: "/leadstatus"
      }
    ]
  },
  {
    title: "Visitor Block List",
    path: "/visitor-block-list",
    icon: getIcon(personDeleteFill)
  },
  {
    title: "Block List",
    path: "/member-block-list",
    icon: getIcon(personDeleteFill)
  },
  {
    title: "Thankyou Note Approval",
    path: "/business-approval",
    icon: getIcon(pricetagsFill)
  },
  {
    title: "Topper Report",
    path: "/topper-report",
    icon: getIcon(report)
  },
  {
    title: "Meeting Feedback Report",
    path: "/meeting-feedback-report",
    icon: getIcon(report)
  },
  {
    title: "Renewal Follow-up By LT",
    path: "/renewal-followup",
    icon: getIcon(report)
  },

  {
    title: "V2V Sheet Report",
    path: "/members-v2v-sheet-report",
    icon: getIcon(report)
  },
  {
    title: "Chapter Attendance Report",
    path: "/chapter-attendance-report",
    icon: getIcon(report)
  },
  {
    title: "Chapter's Member Report",
    path: "/chapters-member-report",
    icon: getIcon(report)
  },
  {
    title: "Member Induction Report",
    path: "/member-induction-report",
    icon: getIcon(report)
  },
  {
    title: "Pin Assign Report",
    path: "/pin-assign-report",
    icon: getIcon(report)
  },
  {
    title: "LVB, City, Chapter's Reports",
    path: "",
    icon: getIcon(report),
    children: [
      { title: "LVB Report", path: "/lvb-report" },
      { title: "City Report", path: "/city-report" },
      { title: "City's Chapter Report", path: "/city-chapter-report" }
    ]
  },
  {
    title: "Member's Reports",
    path: "",
    icon: getIcon(report),
    children: [
      { title: "Business Report", path: "/business-report" },
      { title: "Reference Report", path: "/reference-report" },
      { title: "Testimonial Report", path: "/testimonial-report" },
      { title: "V2V Report", path: "/v2v-report" },
      { title: "Visitor Report", path: "/visitorreport" },
      { title: "Attendance Report", path: "/attendance-report" }
    ]
  },
  {
    title: "Current Record",
    path: "/location",
    icon: getIcon(landmark),
    children: [
      { title: "Business", path: "/business" },
      { title: "Reference", path: "/reference" },
      { title: "Testimonial", path: "/testimonial" },
      { title: "V2V", path: "/v2v" },
      { title: "Visitor", path: "/visitor" }
    ]
  },
  {
    title: "Location",
    path: "/location",
    icon: getIcon(landmark),
    children: [
      { title: "Country", path: "/country" },
      { title: "State", path: "/state" },
      { title: "City", path: "/city" },
      { title: "Landmark", path: "/landmark" }
    ]
  },
  {
    title: "Pin With Point",
    path: "/lvb-pin-badge",
    icon: getIcon(npmFill)
  },
  {
    title: "Pin In Application",
    path: "/achievement-pin-badge",
    icon: getIcon(npmFill)
  },
  {
    title: "Training & Webinar",
    path: "/training-webinar",
    icon: getIcon("material-symbols:videocam-outline-rounded")
  },
  {
    title: "Membership Flow",
    path: "/membership-flow",
    icon: getIcon("material-symbols:image-outline")
  },
  {
    title: "Magazine",
    path: "/magazine",
    icon: getIcon("material-symbols:menu-book-outline")
  },
  {
    title: "LVB Records Dynamic",
    path: "/lvb-records-dynamic",
    icon: getIcon(activity)
  },
  {
    title: "Setting",
    path: "/setting",
    icon: getIcon(setting)
  },
  {
    title: "Description Edit",
    path: "/description-edit",
    icon: getIcon("material-symbols:description")
  },
  {
    title: "Ask",
    path: "/asks",
    icon: getIcon("material-symbols:shield-question-outline")
    // children: [
    //   // { title: "Ask Reasons", path: "/ask-reasons" },
    //   { title: "Asks", path: "/asks" }
    // ]
  },
  {
    title: "Routes List",
    path: "/routes-view",
    icon: getIcon(personDeleteFill)
  },
  {
    title: "How To Use Application",
    path: "/how-to-use-application",
    icon: getIcon(personDeleteFill)
  },
  {
    title: "Stock Management",
    path: "#",
    icon: getIcon("material-symbols:beenhere-outline"),
    children: [
      { title: "Products", path: "/products" },
      { title: "Send Type", path: "/sendtype" },
      { title: "City Stock Report", path: "/citystockreport" },
      { title: "Pending Stock", path: "/pending-stock" },
      // { title: "Pin In Member", path: "/pininmember" },
      { title: "Wallet", path: "/citywallet" }
    ]
  },
  {
    title: "Invoice",
    path: "#",
    icon: getIcon("material-symbols:beenhere-outline"),
    children: [
      { title: "Paid Invoice", path: "/paid-invoice" },
      { title: "Quotation Invoice", path: "/quotation-invoice" },
      { title: "Payment Method", path: "/payment-method" },
      { title: "Customer", path: "/customer" },
      { title: "Product", path: "/product" }
    ]
  },
  {
    title: "Traveling",
    path: "/traveling",
    icon: getIcon(travel)
  }
].filter(Boolean);

// Separate first three (fixed)
const fixedItems = adminconfigData.filter((item) =>
  [
    "Dashboard",
    "Lead",
    "Followup Leads",
    "Lead Reject Reason",
    "Member",
    "Member Deactivate Reason",
    "Green Tick Approval",
    "Blue Tick Approval",
    "OBT Approval"
  ].includes(item.title)
);

// Get the rest (excluding fixed)
const restItems = adminconfigData.filter(
  (item) =>
    ![
      "Dashboard",
      "Lead",
      "Followup Leads",
      "Lead Reject Reason",
      "Member",
      "Member Deactivate Reason",
      "Green Tick Approval",
      "Blue Tick Approval",
      "OBT Approval"
    ].includes(item.title)
);

// Sort rest alphabetically by title
const sortedRest = restItems.sort((a, b) => a.title.localeCompare(b.title));

// Final merged list
const settingItem = adminconfigData.find((item) => item.title === "Setting");
const otherItems = [...fixedItems, ...sortedRest].filter((item) => item.title !== "Setting");
const adminconfig = [...otherItems, settingItem];

const cityconfig = [
  // Fixed items (in order)
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon(dashboard)
  },
  {
    title: "Lead",
    path: "/lead",
    icon: getIcon(lead)
  },
  {
    title: "Followup Leads",
    path: "/followup-leads",
    icon: getIcon("material-symbols:send")
  },
  {
    title: "Member",
    path: "/member",
    icon: getIcon(member)
  },
  {
    title: "OBT Approval",
    path: "#",
    icon: getIcon("material-symbols:beenhere-outline"),
    children: [
      { title: "OBT Member Requests", path: "/obt-apply" },
      { title: "Add OBT", path: "/obt-add" }
    ]
  },
  {
    title: "V2V List",
    path: "/v2vlist",
    icon: getIcon("material-symbols:supervised-user-circle-outline")
  },

  // Sort the rest
  ...[
    {
      title: "City Support",
      path: "/city-support",
      icon: getIcon("material-symbols:support-agent")
    },
    {
      title: "Documents",
      path: "/documents",
      icon: getIcon(documents)
    },
    {
      title: "Meeting",
      path: "/meeting",
      icon: getIcon(meeting)
    },
    {
      title: "Chapter",
      path: "/chapter",
      icon: getIcon(chp)
    },
    {
      title: "Poll Notification",
      path: "/poll",
      icon: getIcon(poll)
    },
    // {
    //   title: "Gallery",
    //   path: "/gallery",
    //   icon: getIcon(camera)
    // },
    {
      title: "Greeting",
      path: "/greeting",
      icon: getIcon(mic)
    },
    {
      title: "Event-Announcement",
      path: "/event-announcement",
      icon: getIcon(event)
    },
    {
      title: "Notifications",
      path: "/lvb-notification",
      icon: getIcon(bell)
    },

    (loginUser?.u_type != 2 || (loginUser?.u_type == 2 && loginUser?.is_subadmin == 1)) && {
      title: "Staff",
      path: "/staff",
      icon: getIcon(staff)
    },
    {
      title: "Suggestion",
      path: "/lvb-suggestion",
      icon: getIcon(lead)
    },
    {
      title: "Deleted Records",
      path: "/deleted-records",
      icon: getIcon("material-symbols:assignment")
    },
    {
      title: "Visitor Block List",
      path: "/visitor-block-list",
      icon: getIcon(personDeleteFill)
    },
    {
      title: "Block List",
      path: "/member-block-list",
      icon: getIcon(personDeleteFill)
    },
    {
      title: "Thankyou Note Approval",
      path: "/business-approval",
      icon: getIcon(pricetagsFill)
    },
    {
      title: "Topper Report",
      path: "/topper-report",
      icon: getIcon(report)
    },
    {
      title: "City's Chapter Report",
      path: "/city-chapter-report",
      icon: getIcon(report)
    },
    {
      title: "Chapter Attendance Report",
      path: "/chapter-attendance-report",
      icon: getIcon(report)
    },
    {
      title: "Chapter's Member Report",
      path: "/chapters-member-report",
      icon: getIcon(report)
    },
    {
      title: "Member Induction Report",
      path: "/member-induction-report",
      icon: getIcon(report)
    },
    {
      title: "Pin Assign Report",
      path: "/pin-assign-report",
      icon: getIcon(report)
    },
    {
      title: "Training & Webinar",
      path: "/training-webinar",
      icon: getIcon("material-symbols:videocam-outline-rounded")
    },
    {
      title: "Traveling",
      path: "/traveling",
      icon: getIcon(travel)
    },
    {
      title: "Magazine",
      path: "/magazine",
      icon: getIcon("material-symbols:menu-book-outline")
    },
    {
      title: "Meeting Feedback Report",
      path: "/meeting-feedback-report",
      icon: getIcon(report)
    },
    {
      title: "Renewal Follow-up By LT",
      path: "/renewal-followup",
      icon: getIcon(report)
    },
    {
      title: "Member's Reports",
      path: "",
      icon: getIcon(report),
      children: [
        { title: "V2V Report", path: "/v2v-report" },
        { title: "Business Report", path: "/business-report" },
        { title: "Reference Report", path: "/reference-report" },
        { title: "Visitor Report", path: "/visitorreport" },
        { title: "Testimonial Report", path: "/testimonial-report" },
        { title: "Attendance Report", path: "/attendance-report" }
      ]
    },
    {
      title: "Current Record",
      path: "/location",
      icon: getIcon(landmark),
      children: [
        { title: "V2V", path: "/v2v" },
        { title: "Business", path: "/business" },
        { title: "Reference", path: "/reference" },
        { title: "Visitor", path: "/visitor" },
        { title: "Testimonial", path: "/testimonial" }
      ]
    },
    {
      title: "V2V Sheet Report",
      path: "/members-v2v-sheet-report",
      icon: getIcon(report)
    },
    {
      title: "Asks",
      path: "/asks",
      icon: getIcon("material-symbols:shield-question-outline")
    },
    {
      title: "Stock Management",
      path: "#",
      icon: getIcon("material-symbols:beenhere-outline"),
      children: [
        { title: "Products", path: "/products" },
        // { title: "Pin In Member", path: "/pininmember" },
        { title: "Stock Wallet", path: "/citywallethistory" }
      ]
    },
    {
      title: "Invoice",
      path: "#",
      icon: getIcon("material-symbols:beenhere-outline"),
      children: [
        { title: "Paid Invoice", path: "/paid-invoice" },
        { title: "Quotation Invoice", path: "/quotation-invoice" }
      ]
    }
  ]
    .filter((f) => f != false) // remove falsy values
    .sort((a, b) => a.title.localeCompare(b.title)) // sort remaining alphabetically
];

const staffconfig = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon(dashboard)
  },
  {
    title: "Lead",
    path: "/lead",
    icon: getIcon(lead)
  },
  {
    title: "Followup Leads",
    path: "/followup-leads",
    icon: getIcon("material-symbols:send")
  },
  {
    title: "Invoice",
    path: "#",
    icon: getIcon("material-symbols:beenhere-outline"),
    children: [
      { title: "Paid Invoice", path: "/paid-invoice" },
      { title: "Quotation Invoice", path: "/quotation-invoice" }
    ]
  },
  {
    title: "Deleted Records",
    path: "/deleted-records",
    icon: getIcon("material-symbols:assignment")
  }
  // {
  //   title: "Stock Management",
  //   path: "#",
  //   icon: getIcon("material-symbols:beenhere-outline"),
  //   children: [
  //     { title: "Products", path: "/products" },
  //     { title: "Pin In Member", path: "/pininmember" },
  //     { title: "Stock Wallet", path: "/citywallethistory" }
  //   ]
  // }
];

// const sidebarConfig = [
//   {
//     title: "Country",
//     path: "/country",
//     icon: getIcon(country)
//   },
//   {
//     title: "State",
//     path: "/state",
//     icon: getIcon(state)
//   },
//   {
//     title: "City",
//     path: "/city",
//     icon: getIcon(city)
//   },
//   {
//     title: "Landmark",
//     path: "/landmark",
//     icon: getIcon(home)
//   },
//   {
//     title: "Member",
//     path: "/member",
//     icon: getIcon(member)
//   },
//   {
//     title: "Meeting",
//     path: "/meeting",
//     icon: getIcon(meeting)
//   },
//   {
//     title: "Greeting",
//     path: "/greeting",
//     icon: getIcon(mic)
//   },
//   {
//     title: "Member Attendance",
//     path: "/memberattendance",
//     icon: getIcon(peopleFill)
//   },
//   {
//     title: "Event-Announcement",
//     path: "/event-announcement",
//     icon: getIcon(event)
//   },
//   // {
//   //   title: "Staff",
//   //   path: "/staff",
//   //   icon: getIcon(staff)
//   // },
//   // {
//   //   title: "Task",
//   //   path: "/task",
//   //   icon: getIcon(task)
//   // },
//   // {
//   //   title: "Lead",
//   //   path: "/lead",
//   //   icon: getIcon(lead)
//   // },
//   {
//     title: "Chapter",
//     path: "/chapter",
//     icon: getIcon(chp)
//   },

//   {
//     title: "Gallery",
//     path: "/gallery",
//     icon: getIcon(camera)
//   },
//   {
//     title: "Poll",
//     path: "/poll",
//     icon: getIcon(poll)
//   },
//   {
//     title: "V2V",
//     path: "/v2v",
//     icon: getIcon(v2v)
//   },
//   {
//     title: "Reference",
//     path: "/reference",
//     icon: getIcon(refrence)
//   },
//   {
//     title: "Business",
//     path: "/business",
//     icon: getIcon(shoppingBagFill)
//   },
//   {
//     title: "Setting",
//     path: "/setting",
//     icon: getIcon(setting)
//   }
//   // {
//   //   title: "login",
//   //   path: "/login",
//   //   icon: getIcon(login)
//   // },
//   // {
//   //   title: "Not found",
//   //   path: "/404",
//   //   icon: getIcon(refrence)
//   // }
// ];

const sidebarConfig =
  loginUser?.u_type == 0 ||
  (loginUser?.p_user_id == 1 && loginUser?.u_type == 2 && loginUser?.is_subadmin == 1)
    ? adminconfig
    : loginUser?.p_user_id == 1 && loginUser?.u_type == 2 && loginUser?.management_p != 0
      ? adminconfig
      : loginUser?.u_type == 1 ||
          (loginUser?.u_type == 2 && loginUser?.management_p != 0) ||
          (loginUser?.u_type == 2 && loginUser?.is_subadmin == 1)
        ? cityconfig
        : staffconfig;

export default sidebarConfig;
